import React, { useEffect, useMemo, useState } from "react";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { Input } from "antd";
import Edit from "../../../assets/Edit.svg";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { toast } from "react-toastify";
import LoadingSpinner from "../../Loading";

const AllStoreProductInfo = ({ additionalData,handleReferesh }) => {
  const { t, i18n } = useTranslation();
  const [flag, setFlag] = useState(false);
  const [editRows, setEditRows] = useState(new Set());
  const [tempEditValues, setTempEditValues] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  console.log("ALL STORE PROD DATA", additionalData);

  const handleEditRow = (row) => {
    setEditRows((prev) => new Set(prev).add(row.original.store_id));
    setTempEditValues((prev) => ({
      ...prev,
      [row.original.store_id]: row.original.sale_price,
    }));
    setIsEditing(true);
  };

  const handlePriceChange = (storeId, value) => {
    if (value === "" || (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 6)) {
      setTempEditValues((prev) => ({
        ...prev,
        [storeId]: value,
      }));
    }
  };
    const data = useMemo(
    () =>
      additionalData?.status
        ? additionalData?.all_product
        : additionalData || [],
    [additionalData]
  );


const handleSaveAll = async () => {
  const allData = [...editRows].map((storeId) => {
    const row = data.find((d) => d.store_id === storeId);

    return {
      store_id: storeId,
      sale_price: Number(tempEditValues[storeId]),
      cost_price: Number(row?.cost_price), // 👈 cost price
    };
  });

  // ❌ VALIDATION
  const invalidRow = allData.find(
    (item) => item.sale_price < item.cost_price
  );

  if (invalidRow) {
    toast.error(
      t("Sale price cannot be less than cost price")
    );
    return; // ⛔ STOP API CALL
  }

  try {
    setLoading(true);

    const payload = {
      store_sales_price_list: allData.map((item) => ({
        store_id: item.store_id,
        product_id: additionalData[0]?.prod_id,
        sale_price: item.sale_price,
      })),
    };

    console.log("FINAL PAYLOAD", payload);

    await axiosInstance.post(
      URLS.UPDATE_ALLSTORE_SALES_PRICE,
      payload
    );
  } catch (error) {
    console.error("Update failed:", error);
  } finally {
    setLoading(false);
    setEditRows(new Set());
    setTempEditValues({});
    setIsEditing(false);
    handleReferesh();
  }
};


  const handleCancel = () => {
    setEditRows(new Set());
    setTempEditValues({});
    setIsEditing(false);
  };


  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setFlag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Store Name")}>
            {t("Store Name")}
          </div>
        ),
        accessor: "store_name",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row.original.store_name}
          </div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Current Sale Price")}>
            {t("Current Sale Price")}
          </div>
        ),
        accessor: "sale_price",
        Cell: ({ row }) => {
          const storeId = row.original.store_id;
          const isRowEditing = editRows.has(storeId);

          return (
            <div className="text-start">
              {isRowEditing ? (
                <Input
                  type="number"
                  className="w-24 border rounded px-2 py-1"
                  placeholder={tempEditValues[storeId]}
                  //   value={tempEditValues[storeId]}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 5)
                    ) {
                      handlePriceChange(storeId, e.target.value);
                    }
                  }}
                  maxLength={5}
                  onKeyPress={(e) => {
                    const value = e.target.value;
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key === "." &&
                      (value === "" || value.includes("."))
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              ) : (
                `EGP ${row.original.sale_price?.toFixed(2)}`
              )}
            </div>
          );
        },
      },
      {
                Header: (
                    <div className="text-start" title={t("Purchase Price")}>
                        {t("Purchase Price")}
                    </div>
                ),
                accessor: "cost_price",
                Cell: ({ row }) => (
                    <div className="text-start">
                        {`EGP ${row.original.cost_price?.toFixed(2)}`}
                    </div>
                ),
            },
      {
        Header: (
          <div className="text-start" title={t("In Stock")}>
            {t("In Stock")}
          </div>
        ),
        accessor: "available_qty",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start">
            {t(row.original.available_qty)} {t(row.original.uom)}
          </div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Current Stock Value")}>
            {t("Current Stock Value")}
          </div>
        ),
        accessor: "current_inventory_value",
        Cell: ({ row }) => (
          <div className="text-start">
            {`EGP ${row.original.current_inventory_value?.toFixed(2)}`}
          </div>
        ),
      },
      {
        Header: "",
        id: "edit",
        Cell: ({ row }) => (
          <div className="flex justify-center">
            {" "}
            {/* Center alignment */}
            <img
              src={Edit}
              style={{
                cursor: "pointer",
                height: "0.9rem",
                width: "0.9rem",
              }}
              alt="Edit"
              className={`mt--2 ${i18n.language == "en" ? "mr-2" : "ml-2"}`}
              onClick={() => {
                handleEditRow(row);
              }}
            />
          </div>
        ),
      },
    ],
    [editRows]
  );
  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  return (
    <>
          {loading && <LoadingSpinner />}
    
      <div
        className="container flex flex-col mx-auto ms-4 mb-6 mt-4"
        style={{ maxWidth: "100%" }}
      >
        {isEditing && (
          <div className="flex justify-end mb-5 me-5">
            {editRows.size === 1 ? (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save")}</span>
              </button>
            ) : (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save_all")}</span>
              </button>
            )}
            <button
              onClick={handleCancel}
              className="w-28 h-8 mt-1 bg-white border border-primaryBlue text-primaryBlue text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              <span>{t("Cancel")}</span>
            </button>
          </div>
        )}
        {additionalData?.length === 0 && flag === false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start ms-2 text-sm ">
                                {column.render("Header")}
                                <span className="">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                          //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
                                index < row.cells.length - 1 ? "relative" : ""
                              } ${
                                cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                              }`}
                              //   style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AllStoreProductInfo;
